const state = () => ({
    user:null,
    userRole:[],
  });
  const getters = {
    getUser(state) {
      return state.user;
    },
    getUserRole(state){
      return state.userRole;
    }
  };
  const mutations = {
    setUser(state, data) {
      state.user = data;
    },
    setUserRole(state, data) {
      state.userRole = data;
    },
  };



  export default {
    state,
    getters,
    mutations,
  };
